import type { PersonalityProfileResponse } from "@/shared/api/generated-backend"
import { PERSONALITY_ASPECT_ORDER } from "./personality-aspects"
import type { PersonalityAspectId, PersonalityProfile } from "./types"

export function extractPersonalityProfile({
	personality_profile: profile,
}: PersonalityProfileResponse): PersonalityProfile | null {
	if (!profile) return null
	const { archetype, big_five, friendship, humor } = profile.personality
	if (!archetype && !big_five && !friendship && !humor) return null
	return profile
}

export function getVisiblePersonalityAspects(profile: PersonalityProfile) {
	return PERSONALITY_ASPECT_ORDER.filter(
		(aspectId: PersonalityAspectId) => profile.visibility[aspectId],
	)
}
